export default __webpack_public_path__ + "static/media/Wall_Window_8x4_02.256.b6126fa0.png";